import { useContext, useEffect, useRef, useState } from "react";
import { IDocumentTypes } from "../../../interfaces/cliente";
import { BodyContainer, Main, StyledButton, StyledLabel } from "../../../components/styled/styled";
import { violet_1 } from "../../../components/styled/constant";
import { BsScissors } from "react-icons/bs";
import { GiSpiralBottle } from "react-icons/gi";
// Socket.IO eliminado 2026-05-19 — la lista de comandas usa polling cada 20s
import useNearScreen from "../../../hooks/useNearScreen/useNearScreen";

import { IProduct, IService, TProductCard, TServiceCard } from "../../../interfaces/productAndServices";
import CardServices from "./cards/cardServices";
import CardProducts from "./cards/cardProducts";
import { createComanda } from "../../../request/comanda";
import { buildClientePayload } from "./buildClientePayload";
import { productContext } from "../../../context/products/ProductsContext";
import { serviceContext } from "../../../context/services/serviceContext";
import { OptionsStyle, PlusCircleAnimated, PlusCircleStyle, WhiteBackground } from "../../../components/styled/styledAddButton";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../../context/UserContext/userContext";
import { showPopup } from "../../../utils/showAlert";
import ClientData from "./clientData/clientData";
import { CollapseDataClient, CollapseDataClientHeader, PopOverContent } from "./styles";
import AddServiceModal from "./modal/addServiceModal";
import { ICart } from "../../../interfaces/cart";
import AddProductModal from "./modal/addProductModal";
import Swal from "sweetalert2";
import useMixpanel from "hooks/useMixpanel/useMixpanel";


export type TInputClient =
    {
        docNumber: string,
        name: string,
        lastName: string,
        email: string,
        phone: string,
        gender: number,
        birth: string,
        clientId: null | number,
    }

export type TErrorsClient =
    {
        email: string,
        phone: string,
        name: string,
        lastName: string,
        docNumber: string,
        birth: string,
        gender: string
    }

export default function AddComanda() {
    const { track } = useMixpanel();
    const { productState } = useContext(productContext);
    const { productsAvaiable } = productState;
    const { serviceState } = useContext(serviceContext);
    const { servicesAvaiable } = serviceState;
    const { userState } = useContext(userContext);
    const { user } = userState;
    const [showPopOver, setShowPopOver] = useState(true);
    const [displayPopover, setDisplayPopover] = useState(false);
    const [documentList, setDocumentList] = useState<IDocumentTypes[]>([]);
    const [documentType, setDocumentType] = useState<string>("DNI");
    const [isLoading, setIsLoading] = useState(true);
    const [addPoS, setAddPoS] = useState<boolean>(false);
    const [showServiceModal, setShowServiceModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);
    const [aux, setAux] = useState<TServiceCard | TProductCard | undefined>(undefined);
    const [index, setIndex] = useState<number | undefined>(undefined);
    const [collapseDataClient, setCollapseDataClient] = useState<boolean>(false);
    const [displayDataClient, setDisplayDataClient] = useState<string>("block");
    const [input, setInput] = useState<TInputClient>({
        docNumber: "",
        name: "",
        lastName: "",
        email: "",
        phone: "",
        gender: 0,
        birth: "",
        clientId: null,
    });

    const [formErrors, setFormErrors] = useState<TErrorsClient>({
        email: '',
        phone: '',
        name: '',
        lastName: '',
        docNumber: '',
        birth: '',
        gender: ''
    });

    // F1 (2026-05-19): estado para deshabilitar el botón "Guardar" durante el submit
    // y evitar comandas duplicadas por doble/triple click en redes lentas.
    const [submitting, setSubmitting] = useState(false);

    const popover = useRef(null)
    const isPopOverNear = useNearScreen(popover, -50)
    const saveButtonRef = useRef<HTMLButtonElement>(null);

    const [cart, setCart] = useState<(ICart | undefined)[]>([]);

    const navigate = useNavigate();



    useEffect(() => {
        if (isPopOverNear) {
            setTimeout(() => {
                setShowPopOver(false)
            }, 3000)
        }
        return () => {
            Swal.close();
        }
    }, [isPopOverNear])

    useEffect(() => {
        setTimeout(() => {
            setDisplayPopover(showPopOver)
        }, 300)
    }, [showPopOver])

    useEffect(() => {
        collapseDataClient ? setTimeout(() => setDisplayDataClient("none"), 500) : setDisplayDataClient("block")
    }, [collapseDataClient])

    useEffect(() => {
        if (!user?.crearComanda) {
            navigate("/comandas")
        }
    }, [user])// eslint-disable-line

    const handleDelete = (index: string) => {
        const newCart = [...cart];
        newCart.splice(Number(index), 1, undefined);
        setCart(newCart);
    }

    const handlerChangeServices = (index: number, amount: number, employeerId: number, e?: IService) => {
        const newCart = [...cart];
        const newItem = newCart[index];
        if (newItem !== undefined) {
            newItem.quantity = amount;
            newItem.service = e;
            newItem.employeeId = employeerId;
            setCart(newCart);
        }
    }

    const handlerChangeProducts = (index: number, amount: number, employeerId: number, e?: IProduct) => {
        const newCart = [...cart];
        const newItem = newCart[index];
        if (newItem !== undefined) {
            newItem.quantity = amount;
            newItem.service = e || newItem.service;
            newItem.employeeId = employeerId;
            setCart(newCart);
        }
    }

    const handlerAddSoPModal = (e: IService | IProduct, type: "s" | "p", quantity?: number) => {
        let newCart = [...cart];
        if (index !== undefined) {
            newCart.splice(index, 1, {
                service: e,
                quantity: quantity || 1,
                employeeId: userState.user?.empleadoId || 0,
                nombreEstado: "EN ESPERA",
                type
            });
        }
        else {
            newCart.push({
                service: e,
                quantity: 1,
                employeeId: userState.user?.empleadoId || 0,
                nombreEstado: "EN ESPERA",
                type
            });
            if (saveButtonRef) {
                setTimeout(() => {
                    saveButtonRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
                }, 370)
            }

        }
        setCart(newCart);
        setShowServiceModal(false);
        setShowProductModal(false);
        setIndex(undefined);
    }

    const handleCloseModal = () => {
        setShowServiceModal(false);
        setShowProductModal(false);
        setAux(undefined);
        setIndex(undefined);
    }

    const handlerClick = (index: string, item: TServiceCard | TProductCard, type: "p" | "s") => {
        setAux(item);
        setIndex(Number(index));
        if (type === "s") {
            setShowServiceModal(true);
        }
        else {
            setShowProductModal(true);
        }
    }

    const validateForm = () => {
        // F2 (2026-05-19): calcular errores en variable local y validar sobre
        // ella. Antes se hacía setFormErrors({...}) y se leía `formErrors`
        // (snapshot stale) en la misma función → forms con campos requeridos
        // vacíos pasaban la validación en el primer submit.
        const nextErrors: TErrorsClient = {
            ...formErrors,
            name: input.name === '' ? 'Nombre es un campo requerido' : formErrors.name,
            birth: (input.birth === '' && user?.tipoPrivacidadDatosCliente === 1) ? 'Fecha de Nacimiento es un campo requerido' : '',
            docNumber: input.docNumber === '' ? 'Num. documento es un campo requerido' : formErrors.docNumber,
        };

        const isvalidate = !Object.values(nextErrors).some(item => item !== '');

        setFormErrors(nextErrors);
        setCollapseDataClient(isvalidate ? true : false);
        return isvalidate;
    }


    const handlerSubmit = async () => {
        // F1 (2026-05-19): early return si ya estamos en submit para evitar
        // que clicks repetidos creen comandas duplicadas mientras la primera
        // request está en vuelo (especialmente en redes lentas / 3G).
        if (submitting) return;

        // Validaciones de guía al usuario — no son errores del sistema, son
        // recordatorios amigables del próximo paso. Las hacemos ANTES del try
        // para no mostrar el ícono "error" (helado triste) en estos casos.
        if (validateForm() === false) {
            return showPopup({
                title: "Falta completar datos del cliente",
                message: "Revisa los campos resaltados arriba para completar el registro.",
                icon: "info",
            });
        }

        type TDetalle = { servicioId: number | null, productoId: number | null, cantidad: number }
        const detalle: TDetalle[] = cart
            .filter(item => item !== undefined)
            .map((item: any) => item?.type === "s"
                ? { servicioId: item.service?.servicioId || null, productoId: null, cantidad: item.quantity }
                : { servicioId: null, productoId: item.service?.productoId || null, cantidad: item.quantity }
            );

        if (detalle.length === 0) {
            return showPopup({
                title: "¡Casi listo!",
                message: "Ahora agrega al menos un servicio o producto para esta comanda. Toca el botón + abajo.",
                icon: "info",
            });
        }

        if (!cart.every(item => (item?.service !== undefined || item === undefined)) || !cart.some(item => item !== undefined)) {
            return showPopup({
                title: "Hay servicios sin completar",
                message: "Tienes que elegir un servicio o producto en cada fila del carrito antes de guardar.",
                icon: "info",
            });
        }

        const clienteId = input.clientId;
        const observaciones = "";
        setSubmitting(true);
        try {
            const cliente = buildClientePayload(input, documentList, documentType);
            const res = await createComanda({ cliente, clienteId, observaciones, detalle });
            if (res.status === "200") {
                // Socket.IO eliminado 2026-05-19 — la lista de /comandas refresca con polling
                console.log(res, 'create comanda desde estilista')
                await showPopup({
                    message: "Comanda creada con éxito",
                    icon: "success",
                });
                window.location.href = '/comandas';
            }
            else {
                throw new Error(res.message);
            }
        }
        catch (err: any) {
            return showPopup({
                title: "No pudimos guardar la comanda",
                message: err?.message || "Hubo un problema de conexión, intenta nuevamente.",
                icon: "error",
            });
        }
        finally {
            setSubmitting(false);
        }
    }


    return (
        <>
            <AddServiceModal
                show={showServiceModal}
                handleCloseModal={handleCloseModal}
                handlerAddSoPModal={handlerAddSoPModal}
                key={"ModalAddService"}
                service={aux}
                servicesAvaiable={servicesAvaiable}
            />
            <AddProductModal
                show={showProductModal}
                handleCloseModal={handleCloseModal}
                handlerAddSoPModal={handlerAddSoPModal}
                key={"ModalAddproduct"}
                product={aux}
                productsAvailable={productsAvaiable}
            />
            <BodyContainer>
                {isLoading &&
                    <WhiteBackground style={{ zIndex: 1000 }} />}
                <div style={{ width: '100%', boxShadow: '' }}>
                    <StyledLabel
                        onClick={() => { navigate('/comandas') }}
                        style={{
                            color: violet_1,
                            cursor: 'pointer',
                            width: '35%',
                            margin: '.4rem 0 1rem 5%',
                        }}
                    >{"< Regresar"}</StyledLabel>
                </div>
                <br></br>

                <CollapseDataClientHeader
                    color="purple_1"
                    turn={collapseDataClient}
                    onClick={() => { setCollapseDataClient(!collapseDataClient) }}
                >{input.name || "Datos del cliente"}</CollapseDataClientHeader>
                {
                    addPoS &&
                    <WhiteBackground onClick={() => setAddPoS(false)} />
                }
                <Main style={{ position: 'relative', height: 'auto' }}>
                    <CollapseDataClient
                        show={!collapseDataClient}
                        display={displayDataClient}
                    >

                        <ClientData
                            documentList={documentList}
                            setDocumentList={setDocumentList}
                            documentType={documentType}
                            setDocumentType={setDocumentType}
                            input={input}
                            setInput={setInput}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            key={"clientData"}
                            formErrors={formErrors}
                            setFormErrors={setFormErrors}
                        />
                        
                    </CollapseDataClient>
                    <br></br>
                    {
                        cart.length > 0 &&
                        cart.map((item, index) => {
                            if (item !== undefined) {
                                if (item.type === "p") {
                                    return <CardProducts
                                        handlerClick={handlerClick}
                                        handlerChangeProducts={handlerChangeProducts}
                                        key={index}
                                        handlerDeleteProduct={handleDelete}
                                        index={index.toString()}
                                        product={item}
                                    ></CardProducts>
                                }
                                return <CardServices
                                    handlerClick={handlerClick}
                                    handlerChangeServices={handlerChangeServices}
                                    key={index}
                                    handlerDeleteService={handleDelete}
                                    index={index.toString()}
                                    service={item}
                                ></CardServices>
                            }
                            return null;
                        })
                    }


                </Main>
                <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', bottom: '15%', right: "5%" }}>
                    <PopOverContent style={{ zIndex: 280 }} show={showPopOver} display={displayPopover} ref={popover}>
                        Agrega aqui tus productos y servicios
                    </PopOverContent>
                    <PlusCircleAnimated
                        turn={addPoS}
                    >

                        <PlusCircleStyle onClick={() => { track("Anadir SoP"); setAddPoS(!addPoS); setCollapseDataClient(true); setShowPopOver(false) }} />
                    </PlusCircleAnimated>
                    {addPoS &&
                        <OptionsStyle onClick={() => setAddPoS(!addPoS)}>
                            <p onClick={() => { track("Añadir servicio"); setShowServiceModal(true) }}>Servicio&nbsp;&nbsp;&nbsp;<BsScissors></BsScissors></p>
                            <p onClick={() => { track("Añadir producto"); setShowProductModal(true) }}>Producto             <GiSpiralBottle></GiSpiralBottle></p>
                        </OptionsStyle>
                    }
                </div>
                <div style={{ position: 'relative', height: '-webkit-fill-available', width: '80%', minHeight: '6rem' }}>
                    <StyledButton
                        ref={saveButtonRef}
                        notEnable={submitting || !cart.every(item => (item?.service !== undefined || item === undefined)) || !cart.some(item => item !== undefined)}
                        disabled={submitting}
                        onClick={handlerSubmit}
                        style={{ width: '100%', position: 'absolute', bottom: '2rem', left: '50%', transform: 'translate(-50%, 0)', cursor: submitting ? 'not-allowed' : undefined }}
                    >{submitting ? "Guardando..." : "Guardar"}</StyledButton>
                </div>
            </BodyContainer>
        </>
    );

}